import React, { useEffect, useRef, useState } from 'react';

import QuestionPreview from 'screens/admin/common/QuestionPreview';
import TemplateQuestionAction from 'screens/admin/common/TemplateCommons/TemplateQuestionAction';
import styled from 'styled-components';
import { StyledBox, StyledPaper, StyledTextField } from 'styles/common';

import theme from 'constants/theme';

import { Typography14 } from 'uiToolkit/Typography';

import './EngagementQuestion.css';

const EngagementQuestionRow = ({
  templateQuestion,
  handleAddQuestionClick,
  handleChangeOrder,
  handleRemoveQuestion,
  handleQuestionDataChange,
  idx,
  handleHoverItem,
  selectedId,
  isLastQuestion,
  uuid,
  isAllowEdit,
}) => {
  const {
    question,
    isRequired,
    question: { isTextRequired, enableFeedbackText },
  } = templateQuestion;
  const { description } = question;

  const handleOnHover = () => {
    handleHoverItem(idx);
  };

  const handleOutHover = () => {
    handleHoverItem(null);
  };

  const [animate, setAnimate] = useState(!!uuid);
  const hasAnimatedOnce = useRef(0);
  // hasAnimatedOnce prevents the animation from running again and again when the component is re-rendered
  // due to reordering the list etc.

  useEffect(() => {
    if (animate) {
      setTimeout(() => {
        setAnimate(false);
        hasAnimatedOnce.current++;
      }, 500);
    }
  }, [animate]);

  return (
    <ParentContainer
      flexcontainer
      onMouseEnter={handleOnHover}
      onMouseLeave={handleOutHover}
      className={animate && !hasAnimatedOnce.current ? 'slideInLeft' : null}
    >
      <StyledPaper
        elevation={0}
        padding="1rem"
        bottomGutter={2}
        flexgrow="1"
        border={selectedId === idx ? theme.palette.borders.blue : theme.palette.borders.lighterGrey}
      >
        <StyledBox flexcontainer flexdirection="column">
          <StyledBox flexcontainer alignitems="center">
            <QuestionNumberPaper
              elevation={0}
              leftGutter={1}
              flexcontainer
              justifycontent="center"
              alignitems="center"
              rightGutter={2}
            >
              {idx + 1}
            </QuestionNumberPaper>
            <Typography14 display="inline">
              {description}
              {isRequired ? ' *' : null}
            </Typography14>
          </StyledBox>
          <StyledBox flexcontainer justifycontent="center" alignitems="center">
            <QuestionPreview showPreviewText={false} question={question} />
          </StyledBox>
          {enableFeedbackText && (
            <StyledBox flexcontainer justifycontent="center" alignitems="center">
              <EditableTextField
                fullWidth
                variant="outlined"
                placeholder={`Add a comment to this question${isTextRequired ? '*' : ''}`}
                multiline
                rows={3}
              />
            </StyledBox>
          )}
        </StyledBox>
      </StyledPaper>
      {selectedId === idx && (
        <MenuContainer>
          <TemplateQuestionAction
            handleAddQuestionClick={handleAddQuestionClick}
            handleChangeOrder={handleChangeOrder}
            handleRemoveQuestion={handleRemoveQuestion}
            handleQuestionDataChange={handleQuestionDataChange}
            questionIndex={idx}
            isRequired={isRequired}
            isLastQuestion={isLastQuestion}
            isAllowEdit={isAllowEdit}
          />
        </MenuContainer>
      )}
    </ParentContainer>
  );
};

export default EngagementQuestionRow;

const QuestionNumberPaper = styled(StyledPaper)`
  height: 32px;
  width: 32px;
  background: ${(props) => props.theme.palette.background.lightGrey4};
  font-size: 14px;
`;

const MenuContainer = styled.div`
  position: absolute;
  right: -110px;
  width: 110px;
  height: calc(100% - 1rem);
  display: flex;
  align-items: center;
`;

const ParentContainer = styled(StyledBox)`
  position: relative;
  padding-right: 10px;
`;

const EditableTextField = styled(StyledTextField)`
  width: 75%;
`;
